import React from 'react';
import DayWisePlan from '../../components/DayWisePlan/DayWisePlan';
import Sequence from '../../components/Sequence/Sequence';
import { JLR_PLANT } from '../../constants';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import TabbedWorkspaceContainer from '../TabbedWorkspaceContainer/TabbedWorkspaceContainer';

const PlanningView = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const tabs = [
    {
      label: 'Plan',
      component: DayWisePlan,
    },
    {
      label: 'Sequence',
      component: Sequence,
    },
  ];
  const title = 'Plan';
  return (
    <TabbedWorkspaceContainer
      pageTitle={title}
      tabs={tabs}
      isJlr={plant.label === JLR_PLANT}
    />
  );
};

export default PlanningView;
